import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "usedcars",
  storage: localStorage
});

import { UPDATE_DATA } from "./mutationTypes";
import search from "./modules/search/search";
import results from "./modules/results/results";
import details from "./modules/details/details";
import global from "./modules/global/global";

export default new Vuex.Store({
  modules: {
    search,
    results,
    details,
    global
  },
  state: {
    carCount: ""
  },
  mutations: {
    [UPDATE_DATA](state, data) {
      state.carCount = data.count;
      state.results.carList = data.results;
      state.results.nextPage = data.next;
    }
  },
  plugins: [vuexPersist.plugin]
});
